/* eslint-disable no-else-return, no-else-return */

import Fade from '@material-ui/core/Fade'
import IconButton from '@material-ui/core/IconButton'
import Snackbar from '@material-ui/core/Snackbar'
import SnackbarContent from '@material-ui/core/SnackbarContent'
import { withStyles } from '@material-ui/core/styles'
import Check from '@material-ui/icons/Check'
import CloseIcon from '@material-ui/icons/Close'
// biome-ignore lint/suspicious/noShadowRestrictedNames: TODO
import Error from '@material-ui/icons/Error'
import Info from '@material-ui/icons/Info'
import Warning from '@material-ui/icons/Warning'
import styled, { ThemeProvider } from 'styled-components'

import theme from '../../utils/theme'

const styles = () => ({
  updateTopRight: {
    top: 90,
  },
  updateCloseIcon: {
    position: 'absolute',
    top: 0,
    right: 0,
    margin: 0,
    zIndex: 10,
    '& button': {
      height: 18,
      width: 18,
      margin: 5,
      borderRadius: '4px',
      padding: 0,
      '& svg': {
        opacity: 0.5,
        color: theme.colors.slate,
        fontSize: 18,
      },
    },
  },
})
function AlertIcon(props) {
  const { variant } = props
  if (variant === 'success') {
    return <Check />
  } else if (variant === 'error') {
    return <Error />
  } else if (variant === 'warning') {
    return <Warning />
  }
  return <Info />
}

function AlertMini(props) {
  const { duration, onClose, open, text, variant, classes, title, isNewLine } = props

  return (
    <ThemeProvider theme={theme}>
      <Snackbar
        open={open}
        anchorOrigin={{
          horizontal: 'right',
          vertical: 'top',
        }}
        autoHideDuration={duration}
        TransitionComponent={Fade}
        onClose={onClose}
        variant={variant}
        classes={{
          anchorOriginTopRight: classes.updateTopRight,
        }}
      >
        <StyledSnack
          message={
            <SnackInner>
              <SnackIcon className={variant}>
                <AlertIcon variant={variant} />
              </SnackIcon>
              <SnackText style={{ textAlign: 'left' }}>
                <span>
                  <Title>{title}</Title>
                  {isNewLine ? (
                    <span>
                      <br />
                      {text}
                    </span>
                  ) : (
                    ` ${text}`
                  )}
                </span>
              </SnackText>
            </SnackInner>
          }
          classes={{
            action: classes.updateCloseIcon,
            message: classes.widthfix,
          }}
          action={[
            <IconButton key="close" aria-label="Close" onClick={onClose}>
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </Snackbar>
    </ThemeProvider>
  )
}

AlertMini.defaultProps = {
  duration: 5000,
  open: false,
  variant: 'info',
}

const StyledSnack = styled(SnackbarContent)`
  border-radius: 4px;
  && {
    padding: 0px;
    background-color: var(--gameday-status-alertMiniBG, ${theme.status.alertMiniBG});
    & > div {
      padding: 0px;
      border-radius: 4px;
    }
  }
`

const SnackInner = styled.div`
  border-radius: 4px;
  display: flex;
  min-height: 74px;
`

const SnackIcon = styled.div`
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  &.success {
    background-color: ${props => props.theme.status.successColor};
  }
  &.warning {
    background-color: ${props => props.theme.status.warningColor};
  }
  &.error {
    background-color: ${props => props.theme.status.errorColor};
  }
  &.info {
    background-color: ${props => props.theme.status.infoColor};
  }
`

const SnackText = styled.div`
  max-width: 80%;
  min-width: 240px;
  padding: 19px 0 19px 18px;
  background-color: var(--gameday-status-alertMiniBG, ${theme.status.alertMiniBG});
  font-size: 0.9375rem;
  color: var(--gameday-status-alertMini, ${theme.status.alertMini});
  align-items: center;
  display: flex;
  line-height: 1.2;
`

const Title = styled.span`
  font-weight: bold;
`

const AlertMiniComponent = withStyles(styles)(AlertMini)
AlertMiniComponent.displayName = 'AlertMini'
export default AlertMiniComponent
